export default function ThemeWrapper({ children }) {
    return (
        <div className="bg-gray-50 border-t-4 border-red-600">
            {children}
        </div>
    );
}
